import { gql } from '@apollo/client';
import { RatificationManagerFields } from '../fragments';
import { UserIdentification } from '../user/fragments';
import { CollectionManagerBasicFields } from '../collection/fragments';
import { BaseContactsField } from '../customers/fragment';

export const SEND_RATIFICATION_MAIL = gql`
  mutation SendRatificationMail(
    $contactsIds: [Int]!
    $mailType: String!
    $withCessionCertificate: Boolean!
    $managersIds: [Int]
    $invoiceIds: [Int]
  ) {
    sendRatificationMail(
      contactsIds: $contactsIds
      mailType: $mailType
      withCessionCertificate: $withCessionCertificate
      managersIds: $managersIds
      invoiceIds: $invoiceIds
    ) {
      managers {
        ...RatificationManagerFields
      }
    }
  }
  ${RatificationManagerFields}
`;

export const SEND_COLLECTION_MAIL = gql`
  mutation SendCollectionMail(
    $collectionContactIds: [Int]!
    $collectionManagerIds: [Int]!
    $mailType: String!
    $attachmentIds: [Int]
    $assignmentIds: [Int]
  ) {
    sendCollectionMail(
      collectionManagerIds: $collectionManagerIds
      collectionContactIds: $collectionContactIds
      attachmentIds: $attachmentIds
      assignmentIds: $assignmentIds
      mailType: $mailType
    ) {
      collectionManagers {
        id
        collector {
          ...UserIdentification
        }
        collectionPriority {
          value
        }
        actions {
          id
          comment
          createdAt
          actionType
          contacts {
            ...BaseContactsField
          }
          author {
            ...UserIdentification
          }
        }
      }
    }
  }
  ${UserIdentification}
  ${BaseContactsField}
`;

export const GET_RATIFICATION_MAIL_PREVIEW = gql`
  mutation GetRatificationMailPreview(
    $mailType: String!
    $ratificationManagerIds: [String]!
  ) {
    getRatificationMailPreview(
      mailType: $mailType
      ratificationManagerIds: $ratificationManagerIds
    ) {
      preview
    }
  }
`;

export const ADD_DATA_FOR_COLLECTION = gql`
  mutation AddDataForCollection(
    $collectionManagerIds: [Int]!
    $collectionContactIds: [Int]!
    $dateToPay: String!
    $paymentMethod: PaymentMethodEnum!
  ) {
    addDataForCollection(
      dataForCollection: {
        collectionManagerIds: $collectionManagerIds
        collectionContactIds: $collectionContactIds
        dateToPay: $dateToPay
        paymentMethod: $paymentMethod
      }
    ) {
      collectionManagers {
        id
        dataforcollectionSet {
          id
          paymentMethod
          dateToPay
        }
      }
    }
  }
`;

export const ADD_COLLECTION_PROROGATION = gql`
  mutation AddCollectionProrogation(
    $collectionManagerIds: [Int]!
    $prorogationDays: Int!
  ) {
    addCollectionProrogation(
      collectionManagerIds: $collectionManagerIds
      prorogationDays: $prorogationDays
    ) {
      collectionProrogations {
        id
        prorogationDate
      }
    }
  }
`;

export const REINTEGRATION_FLAG_ACTIVATION = gql`
  mutation ReintegrationFlagActivation($managerId: Int!, $newStatus: Boolean!) {
    reintegrationFlagActivation(managerId: $managerId, newStatus: $newStatus) {
      collectionManager {
        ...CollectionManagerBasicFields
      }
    }
  }
  ${CollectionManagerBasicFields}
`;

export const CREATE_RATIFICATION_ACTION = gql`
  mutation CreateRatificationAction(
    $ratificationManagerIds: [Int]!
    $ratificationContactsIds: [Int]
    $ratificationActionType: RatificationActionEnum!
    $ratificationComment: String
    $ratificationChannel: RatificationChannelEnum!
    $responded: Boolean
  ) {
    createRatificationAction(
      ratificationActionInput: {
        ratificationManagerIds: $ratificationManagerIds
        ratificationContactsIds: $ratificationContactsIds
        ratificationActionType: $ratificationActionType
        ratificationComment: $ratificationComment
        ratificationChannel: $ratificationChannel
        responded: $responded
      }
    ) {
      managers {
        ...RatificationManagerFields
      }
    }
  }
  ${RatificationManagerFields}
`;

export const CREATE_OPERATIVE_REQUEST = gql`
  mutation CreateOperativeRequest(
    $requestType: String!
    $documentType: String!
    $documentIds: [Int]!
    $comment: String!
  ) {
    createOperativeRequest(
      requestType: $requestType
      documentType: $documentType
      documentIds: $documentIds
      comment: $comment
    ) {
      invoices {
        id
        lastOperativeRequestManager {
          id
          status
        }
      }
      purchaseOrders {
        id
        lastOperativeRequestManager {
          id
          status
        }
      }
    }
  }
`;

export const REJECT_OPERATIVE_REQUEST = gql`
  mutation RejectOperativeRequest(
    $operativeRequestId: ID!
    $parameters: [GenericParameterType!]!
  ) {
    rejectOperativeRequest(
      operativeRequestId: $operativeRequestId
      parameters: $parameters
    ) {
      operativeRequest {
        id
        status
        comment
        operativeRequestType {
          id
          shortName
          name
          code
        }
      }
    }
  }
`;

export const ACCEPT_OPERATIVE_REQUEST = gql`
  mutation AcceptOperativeRequest(
    $operativeRequestId: ID!
    $parameters: [GenericParameterType!]!
  ) {
    acceptOperativeRequest(
      operativeRequestId: $operativeRequestId
      parameters: $parameters
    ) {
      operativeRequest {
        id
        status
        comment
        operativeRequestType {
          id
          shortName
          name
          code
        }
      }
    }
  }
`;
